import React from "react";
import { Link } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";

const Navbar = () => {
  return (
    <div className="bg-white hidden md:block mb-3">
      <div className="container mx-auto flex justify-center h-10">
        <div className="nav-items flex items-center">
          <ul className="flex space-x-10 text-black text-sm font-bold tracking-widest">
            <li className="hover:text-[#2E3192]">
              <Link to="/">HOME</Link>
            </li>
            <li className="hover:text-[#2E3192]">
              <Link to="/about">ABOUT</Link>
            </li>
            <li className="hover:text-[#2E3192]">
              <div className="dropdown">
                <span className="flex items-center">
                  OUR COURSES
                  <MdArrowForwardIos className="ml-1" />
                </span>
                <div className="dropdown-content text-white text-sm font-normal tracking-widest space-y-5">
                  <p>
                    <Link to="/courses/HighSchool" className="flex items-center">
                      HIGH SCHOOL LEVEL
                      
                    </Link>
                  </p>
                  <p>
                    <Link to="/courses/Engineering" className="flex items-center">
                      ENGINEERING PREPARATIONS
                     
                    </Link>
                  </p>
                  <p>
                    <Link to="/courses/Medical" className="flex items-center">
                      MEDICAL PREPARATIONS
                    
                    </Link>
                  </p>
                  <p>
                    <Link to="/courses/Commerce" className="flex items-center">
                      COMMERCE 
                    </Link>
                  </p>
                </div>
              </div>
            </li>
           
            <li className="hover:text-[#2E3192]">
              <div className="dropdown">
                <span className="flex items-center">
                  ENTRANCE EXAMS
                  <MdArrowForwardIos className="ml-1" />
                </span>
                <div className="dropdown-content1 text-white text-sm font-normal tracking-widest space-y-5">
                  <p>
                    <Link to="/jee" className="flex items-center">
                      IITJEE
                      
                    </Link>
                  </p>
                  <p>
                    <Link to="/neet" className="flex items-center">
                      NEET
                      
                    </Link>
                  </p>
                  <p>
                    <Link to="/cet" className="flex items-center">
                      KCET
                     
                    </Link>
                  </p>
                  
                </div>
              </div>
            </li>
            <li className="hover:text-[#2E3192]">
              <Link to="/results">RESULT</Link>
            </li>
            <li className="hover:text-[#2E3192]">
              <Link to="/exam">NOTIFICATION</Link>
            </li>
            <li className="hover:text-[#2E3192]">
              <Link to="/gallery">GALLERY</Link>
            </li>
            <li className="hover:text-[#2E3192]">
              <Link to="/contact">CONTACT</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
